import * as tslib_1 from "tslib";
import * as React from 'react';
import { propsDeserializer } from '../../utils/propsSerializer';
export function withPropsDeserializer(Component) {
    return function (props) {
        var shouldDeserialize = props.hasOwnProperty('__serializedData');
        var nextProps = shouldDeserialize ? propsDeserializer(props) : props;
        return React.createElement(Component, tslib_1.__assign({}, nextProps));
    };
}
//# sourceMappingURL=propsDeserializer.js.map